import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Sparkles, X, Tag } from "lucide-react";

const PLACEMENT_PATH = { store: "/store", training: "/training", community: "/community" };

export default function PromoBanner() {
  const [promo, setPromo] = useState(null);
  const [dismissed, setDismissed] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/promo/active");
        setPromo(data || null);
        if (data) setDismissed(localStorage.getItem(`pb_promo_dismissed_${data.id}`) === "1");
      } catch { setPromo(null); }
    })();
  }, [location.pathname]);

  if (!promo || dismissed) return null;
  const matches = promo.placement === "all" || PLACEMENT_PATH[promo.placement] === location.pathname;
  if (!matches) return null;

  const dismiss = () => { localStorage.setItem(`pb_promo_dismissed_${promo.id}`, "1"); setDismissed(true); };

  return (
    <div data-testid="promo-banner"
      className="relative mb-6 overflow-hidden border border-pb-red bg-gradient-to-r from-pb-red/15 via-pb-surface to-pb-surface animate-fade-up">
      <div className="absolute inset-y-0 left-0 w-1.5 bg-pb-red" />
      <div className="flex flex-wrap items-center gap-4 p-4 pl-6">
        {promo.image ? (
          <img src={promo.image} alt={promo.title} data-testid="promo-banner-image"
            className="w-24 h-16 object-contain bg-black border border-pb-red/40 shrink-0 hidden sm:block" />
        ) : (
          <Sparkles className="w-5 h-5 text-pb-red shrink-0" />
        )}
        <div className="flex-1 min-w-[200px]">
          <div className="flex items-center gap-2 flex-wrap">
            <span className="font-display font-black uppercase text-lg tracking-tight">{promo.title}</span>
            {promo.discount_percent > 0 && (
              <span className="inline-flex items-center gap-1 bg-pb-red text-black text-[11px] font-bold uppercase tracking-widest px-2 py-0.5">
                <Tag className="w-3 h-3" />{promo.discount_percent}% Off {promo.target_category === "All" ? "Sitewide" : promo.target_category}
              </span>
            )}
          </div>
          <p className="text-sm text-zinc-300 mt-0.5">{promo.message}</p>
        </div>
        <button data-testid="promo-cta" onClick={() => navigate("/store")}
          className="bg-pb-red text-black font-bold uppercase tracking-widest text-xs px-5 py-2.5 hover:bg-[#BEF264] active:scale-95 transition-all">
          {promo.cta || "Shop Now"}
        </button>
        <button data-testid="promo-dismiss" onClick={dismiss} className="text-zinc-500 hover:text-white shrink-0">
          <X className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
}
